/* eslint-disable react/prop-types */
import { useState } from "react";

import { alignItems, colors, strCode } from "../../../consts";
import { t } from "../../../services";

import { Paragraph2 } from "../../../components/Text/Paragraphs";
import TextOverflowWrapper from "../../../components/TextOverflowWrapper/TextOverflowWrapper";

import { FlexContainers, GradientLoader, WrapperContainer } from "../../../components";
import { CellWrapper, EmptyCell } from "../../../components/Table/styled";
import { DeviceImageContainer } from "../DeviceTable/styled";
import { deviceUtil } from "../../../utils";

const checkEmpty = (Component, value, danger = true) => {
  return value ? Component : <EmptyCell danger={danger}>{t(strCode.EMPTY_CELL_INFO)}</EmptyCell>;
};

export const ImportedDevicesTableColumns = [
  {
    Header: "#",
    accessor: "index",
    Cell: ({ cell }) => (
      <CellWrapper width={`fit-content`}>
        <Paragraph2>
          <b>{cell.value}</b>
        </Paragraph2>
      </CellWrapper>
    )
  },
  {
    Header: strCode.DEVICE_TITLE,
    accessor: "device_model",
    Cell: ({ cell, cellWidth5, cellWidth8 }) => {
      const [isImageLoaded, setIsImageLoaded] = useState(false);
      const [deviceImage, setDeviceImage] = useState();

      const record = cell?.row?.original;

      const isMercuryDevice = record?.isMercuryDevice;

      deviceUtil.getDeviceImageAsset(record?.deviceImage, isMercuryDevice).then((res) => {
        setDeviceImage(res);
      });

      return (
        <CellWrapper maxWidth={cellWidth5}>
          <WrapperContainer Container={FlexContainers.FlexRowStart} gap={16} maxWidth={cellWidth5}>
            <DeviceImageContainer Container={FlexContainers.FlexRowCenter}>
              {!isImageLoaded && (
                <GradientLoader width={48} height={48} animationDuration={48} borderRadius={8} />
              )}
              <img
                src={deviceImage}
                alt="device"
                style={{ display: isImageLoaded ? "block" : "none" }}
                onLoad={() => setIsImageLoaded(true)}
              />
            </DeviceImageContainer>

            <WrapperContainer
              Container={FlexContainers.FlexColumnStart}
              alignItems={alignItems.start}
              maxWidth={cellWidth8}>
              {checkEmpty(
                <TextOverflowWrapper
                  width={cellWidth8}
                  style={{ color: colors.RAISIN_100, fontWeight: 600 }}>
                  {t(cell.value)}
                </TextOverflowWrapper>,
                cell.value
              )}

              {checkEmpty(
                <TextOverflowWrapper
                  style={{
                    color: colors.RAISIN_70,
                    fontWeight: 500,
                    fontSize: "14px"
                  }}>
                  {record.type}
                </TextOverflowWrapper>,
                record.type
              )}
            </WrapperContainer>
          </WrapperContainer>
        </CellWrapper>
      );
    }
  },

  {
    Header: strCode.SERIAL_NUMBER_TITLE,
    accessor: "dusn",
    Cell: ({ cell, cellWidth8, searchedText }) => {
      const record = cell?.row?.original;
      const hasError = record?.errors?.dusn;

      return (
        <CellWrapper maxWidth={cellWidth8}>
          {checkEmpty(
            <TextOverflowWrapper
              style={{ color: hasError ? colors.ERROR : colors.RAISIN_70 }}
              highlightedText={searchedText}>
              {cell.value}
            </TextOverflowWrapper>,
            cell.value
          )}
        </CellWrapper>
      );
    }
  },

  {
    Header: strCode.CODENTIFY_TITLE,
    accessor: "codentify",
    Cell: ({ cell, cellWidth8 }) => {
      const record = cell?.row?.original;
      const hasError = record?.errors?.codentify;

      return (
        <CellWrapper maxWidth={cellWidth8}>
          {checkEmpty(
            <TextOverflowWrapper style={{ color: hasError ? colors.ERROR : colors.RAISIN_70 }}>
              {cell.value}
            </TextOverflowWrapper>,
            cell.value
          )}
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.FIRMWARE_VERSION_TITLE,
    accessor: "latest_firmware_version",
    Cell: ({ cell }) => {
      return (
        <CellWrapper width={`fit-content`} minWidth={"80px"}>
          <TextOverflowWrapper style={{ color: colors.RAISIN_70 }}>
            {cell.value ? cell.value : t(strCode.UNKNOWN)}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  }
];
